import "../Styles/Home.css";
import Header from "../Components/MUI/Header";
import { useState, useEffect, useRef } from "react";
import { motion, AnimatePresence } from "framer-motion";
import useDarkMode from "use-dark-mode";
import OverlayContainer from "../Components/MUI/OverlayContainer";
import { animations } from "../animations/animations";
import Form from "../Components/MUI/Form";
import Swal from "sweetalert2";
import logo from "../assets/logo1.png";
import logo2 from "../assets/logo2.png";
import logo3 from "../assets/logo3.png";

import { useAuth } from "../Components/AuthContext";
import { ref, get } from "firebase/database";
import {
  onAuthStateChanged,
  signInWithEmailAndPassword,
  signOut,
  sendPasswordResetEmail,
} from "firebase/auth";
import {
  auth,
  database,
  GoogleAuthProvider,
  signInWithPopup,
} from "../Firebase/firebaseConfig";

//imgs
import logoImg from "../assets/sportsgate-logo.png";
import filter from "../assets/filter.png";

import arrowDown from "../assets/arrow-down.png";
import rechIcon from "../assets/search.png";
import prod2 from "../assets/prod2.png";
import prod3 from "../assets/prod3.png";
import prod4 from "../assets/prod4.png";
import add from "../assets/add.png";

import whiteLoader from "../assets/whiteLoader.gif";

import fb from "../assets/fb.png";
import insta from "../assets/insta.png";
import tiktok from "../assets/tiktok.png";

import google from "../assets/google.svg";
import userIcon from "../assets/User Male_1.svg";

import PasswordIcon from "../assets/Lock.svg";
import aboutBack from "../assets/aboutback.jpg";

import contact1 from "../assets/contact1.png";
import contact2 from "../assets/contact2.png";
import contact3 from "../assets/contact3.png";
import contact4 from "../assets/contact4.png";

import exit from "../assets/exit.png";
import CartOverlayConent from "./cartOverlayContent";
import SelectOption from "../Components/MUI/SelectOption";
import {
  getAllProducts,
  getAllTags,
  getProductById,
  getReviewsById,
  incrNumberSales,
  saveOrder,
  saveReview,
  getOrdersByUserId,
  getAllCategories,
  getActiveContent,
  uploadFileToStorage,
  saveWarrantyClaim,
} from "../Utils/Utils";
import SignUpOverlayContent from "./SignUpOverlayContent";
import useScrollSpy from "./MUI/useScrollSpy";
import NetTestOverlay from "./MUI/NetTestOverlay";
import FlashPopUp from "./MUI/FlashPopUp";
import Tabs from "./MUI/Tabs";
import ProductDetailsTabs from "./ProductDetailsTab";
import FileInput from "./MUI/FileInput";
import CategoriesSection from "./CategoriesSection";
import AfterSalesServiceSection from "./AfterSalesSections";

function Home() {
  const navLinks = [
    "Accueil",
    "Produits",
    "Recommandé",
    "Recherche",
    "A Propos",
    "Après-vente",
    "Contact",
  ];

  const sectionRefs = [
    useRef(null), // 0: home
    useRef(null), // 1: recommended
    useRef(null), // 2: categories
    useRef(null), // 3: products
    useRef(null), // 4: about
    useRef(null), // 5: after-vente
    useRef(null), // 6: contact
  ];

  const darkMode = useDarkMode(false);

  const textColor = "black";
  const actionBtnBgColor = "#fbf008";

  const handleNavLinkClick = (index) => {
    setSelectedNavIndex(index);

    sectionRefs[index].current?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  const [pageContent, setPageContent] = useState(null);
  const [isPageLoad, setIsPageLoaded] = useState(true);
  const [toggleOverlay, setToggleOverlay] = useState(false);

  const [toggleProductOverlay, setToggleProductOverlay] = useState(false);
  const [toggleCartOverlay, setToggleCartOverlay] = useState(false);

  const [toggleDetailOverlay, setToggleDetailOverlay] = useState(false);

  const [toggleReviewOverlay, setToggleReviewOverlay] = useState(false);

  const [toggleCompleteInfosOverlay, setToggleCompleteInfosOverlay] =
    useState(false);

  const [toggleCreateAcountOverlay, setToggleCreateAcountOverlay] =
    useState(false);

  const [showEmailVerificationOverlay, setShowEmailVerificationOverlay] =
    useState(false);
  const algeriaWilayas = [
    "Adrar",
    "Chlef",
    "Laghouat",
    "Oum El Bouaghi",
    "Batna",
    "Béjaïa",
    "Biskra",
    "Béchar",
    "Blida",
    "Bouira",
    "Tamanrasset",
    "Tébessa",
    "Tlemcen",
    "Tiaret",
    "Tizi Ouzou",
    "Alger",
    "Djelfa",
    "Jijel",
    "Sétif",
    "Saïda",
    "Skikda",
    "Sidi Bel Abbès",
    "Annaba",
    "Guelma",
    "Constantine",
    "Médéa",
    "Mostaganem",
    "MSila",
    "Mascara",
    "Ouargla",
    "Oran",
    "El Bayadh",
    "Illizi",
    "Bordj Bou Arreridj",
    "Boumerdès",
    "El Tarf",
    "Tindouf",
    "Tissemsilt",
    "El Oued",
    "Khenchela",
    "Souk Ahras",
    "Tipaza",
    "Mila",
    "Aïn Defla",
    "Naâma",
    "Aïn Témouchent",
    "Ghardaïa",
    "Relizane",
    "Timimoun",
    "Bordj Badji Mokhtar",
    "Ouled Djellal",
    "Béni Abbès",
    "In Salah",
    "In Guezzam",
    "Touggourt",
    "Djanet",
    "El M'Ghair",
    "El Meniaa",
  ];

  const [phone, setPhone] = useState("");
  const [wilaya, setWilaya] = useState("");
  const [address, setAddress] = useState("");

  const handleBtnActionClick = () => {
    console.log("Button action clicked");
    setToggleOverlay(!toggleOverlay);
  };

  const [selectedNavIndex, setSelectedNavIndex] = useState(0);

  const [isHovered, setIsHovered] = useState(false);
  const [animateCart, setAnimateCart] = useState(false);

  const [isInitialLoad, setIsInitialLoad] = useState(true);

  /* Product Page*/
  const [hoveredProduct, setHoveredProduct] = useState(null);
  /* end Product Page*/

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const [showPassword, setShowPassword] = useState(false);

  const [loginLoading, setLoginLoading] = useState(false); // Loading state
  const [loginError, setLoginError] = useState(null);
  const [guestName, setGuestName] = useState("");
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [resetEmail, setResetEmail] = useState("");
  const [resetEmailSent, setResetEmailSent] = useState(false);

  const validateForm = () => {
    if (!username) {
      setLoginError("L'email est requis.");
      return false;
    } else if (!password) {
      setLoginError("Le mot de passe est requis.");
      return false;
    }
    return true;
  };

  const { currentUser, setCurrentUser } = useAuth();

  const handleForgotPassword = async () => {
    if (!resetEmail) {
      setLoginError("Veuillez entrer votre email.");
      return;
    }
    setLoginLoading(true);
    try {
      await sendPasswordResetEmail(auth, resetEmail);
      setResetEmailSent(true);
      setLoginError("");
    } catch (error) {
      console.error(error);
      setLoginError(
        "Échec de l'envoi de l'email de réinitialisation. Vérifiez si l'email est correct.",
      );
    } finally {
      setLoginLoading(false);
    }
  };

  var handleLoginClick = async () => {
    console.log("Login button clicked");
    console.log(username + " " + password);

    setLoginError(""); // Clear error message
    if (!validateForm()) {
      setLoginLoading(false); // Stop loading if validation fails
      return;
    }

    setLoginLoading(true); // Show loading icon

    setTimeout(async () => {
      try {
        const userCredential = await signInWithEmailAndPassword(
          auth,
          username,
          password,
        );
        const user = userCredential.user;

        if (user) {
          console.log("User exists:", user);
          // Perform any post-login logic, like redirecting to a different page
          const userRef = ref(database, "users/"); // Assuming user data is stored under 'users/{uid}'
          const userSnapshot = await get(userRef);

          if (userSnapshot.exists()) {
            const usersData = userSnapshot.val();
            const foundUser = Object.values(usersData).find(
              (u) => u.uid === user.uid,
            );

            if (foundUser) {
              console.log("User Data:", foundUser);

              user.name = foundUser.lastName;
              user.dataInfos = foundUser;
              user.loginSrc = "email";

              setTimeout(() => {
                setToggleOverlay(false);
              }, 1000);
              // Now you can access fields like foundUser.firstName, foundUser.lastName, etc.
              getOrdersByUserId(user.id).then((orders) => {
                console.log(".......... orders by user");
                console.log(orders);

                user.orders = orders;
                setCurrentUser(user);
              });

              setIsPageLoaded(false);
              setTimeout(() => {
                setIsPageLoaded(true);
              }, 1000);

              setUsername("");
              setPassword("");
            } else {
              console.log("User not found in the database!");
            }
          } else {
            console.log("No user data found!");
          }
        }
      } catch (error) {
        console.error("Error logging in:", error);
        setLoginError("Invalid email or password.");
      } finally {
        setLoginLoading(false); // Hide loading icon after the login attempt
      }
    }, 2000);
  };

  const handleGoogleSignIn = async () => {
    const provider = new GoogleAuthProvider();
    try {
      setToggleOverlay(false);
      const result = await signInWithPopup(auth, provider);
      const user = result.user;

      if (user) {
        // Display success message using SweetAlert

        Swal.fire({
          icon: "success",
          title: "Sign-in successful!",
          text: `Welcome, ${user.displayName}`,
          confirmButtonColor: "#fbf008",
          iconColor: "#fbf008",
          confirmButtonText: "OK",
          customClass: {
            popup: "popup",
            icon: "custom-icon",
            container: "popup-container",
            confirmButton: "confirmButton",
          },
        });

        user.name = user.displayName.split(" ")[0];
        user.loginSrc = "google";
        console.log(user);

        console.log("getting orders");
        getOrdersByUserId(user.id).then((orders) => {
          console.log("..........");
          console.log(orders);
          user.orders = orders;
          setCurrentUser(user);
        });

        console.log(user.orders);

        setIsPageLoaded(false);
        setTimeout(() => {
          setIsPageLoaded(true);
        }, 1000);
      }
    } catch (error) {
      console.error("Error signing in: ", error);

      // Display error message using SweetAlert
      Swal.fire({
        icon: "error",
        title: "Sign-in failed",
        text: error.message,
        confirmButtonColor: "#fbf008",
        iconColor: "#fbf008",
        confirmButtonText: "OK",
        customClass: {
          popup: "popup",
          icon: "custom-icon",
          container: "popup-container",
          confirmButton: "confirmButton",
        },
      });
    }
  };

  const handleLogout = async () => {
    try {
      await signOut(auth);
      setCurrentUser(null);
      console.log("User signed out");

      setIsPageLoaded(false);
      setTimeout(() => {
        setIsPageLoaded(true);
      }, 0);
    } catch (error) {
      console.error("Error signing out:", error);
    }
  };

  /*Recomanded Product*/
  const [products, setProducts] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);

  const [selectedVariant, setSelectedVariant] = useState(null);

  const handleBuyClick = (product) => {
    setSelectedProduct(product);
    setIsInitialLoad(false);
  };

  /*end Recomanded Product*/

  /*Commande Form*/
  const [formValues, setFormValues] = useState({
    name: "",
    phone: "",
    address: "",
    wilaya: "",
    quantity: 1,
  });
  const [formErrors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Form validation function
  const validateCommandeForm = () => {
    let formErrors = {};
    if (!formValues.name) formErrors.name = "Name is required";
    if (!formValues.phone) formErrors.email = "Phone is required";
    if (!formValues.address) formErrors.address = "Address is required";

    if (!formValues.wilaya) formErrors.address = "Address is required";
    return formErrors;
  };

  // Handle form input change
  const handleChange = (e, name) => {
    console.log("changing");
    const value = e.target.value;
    console.log(name);
    if (name === "quantity") {
      const parsedValue = Number(value);
      const normalizedValue = Number.isNaN(parsedValue)
        ? 1
        : Math.max(1, parsedValue);
      setFormValues({ ...formValues, [name]: normalizedValue });
      return;
    }
    setFormValues({ ...formValues, [name]: value });
  };

  // Handle form submission
  const handleSubmit = (e) => {
    console.log("submit clicked");
    console.log(formValues);
    console.log(selectedProduct.id);

    e.preventDefault();
    const formErrors = validateCommandeForm();
    if (Object.keys(formErrors).length === 0) {
      setIsSubmitting(true);
      console.log(selectedProduct);
      console.log(parseFloat(selectedProduct.price));
      const unitPrice = Number(
        selectedVariantData?.price ?? selectedProduct?.price ?? 0,
      );
      var order = {
        clientId: null,
        clientName: formValues.name,
        clientPhone: formValues.phone,
        address: formValues.address,
        wilaya: formValues.wilaya,
        products: [
          { productId: selectedProduct.id, quantity: formValues.quantity },
        ],
        total: unitPrice * Number(formValues.quantity),
        date: new Date().toISOString().split("T")[0],
        orderStatus: false,
        paymentStatus: false,
        appSource: "SportsGate Web App",
      };
      console.log(order);
      saveOrder(order).then(() => {
        incrNumberSales(selectedProduct.id);
        // Simulate form submission
        setTimeout(() => {
          Swal.fire({
            icon: "success",
            title: "Order placed successfully!",
            html: `<p class="popup-custom-text small-text grey bold">Your order for ${selectedProduct.name} has been placed.</p>`,
            confirmButtonColor: "#fbf008",
            iconColor: "#fbf008",
            confirmButtonText: "Done",
            customClass: {
              popup: "popup", // Add your own class for styling the entire popup
              icon: "custom-icon", // Add your own class for styling the icon
              container: "popup-container",
              confirmButton: "confirmButton",
              validationMessage: "validationMessage",
              title: "popup-custom-title",
              image: "custom-image",
            },
          });
          setIsSubmitting(false);
          setToggleProductOverlay(false); // Close overlay after success
          setToggleDetailOverlay(false);
          setFormValues({
            name: "",
            phone: "",
            address: "",
            quantity: 1,
          });
          setErrors({});
        }, 500);
      });
    } else {
      setErrors(formErrors);
    }
  };

  const validateCompleteForm = () => {
    const errors = {};
    if (!currentUser && !guestName) errors.name = "Name is required";
    if (!phone) errors.phone = "Phone number is required";
    if (!wilaya) errors.wilaya = "Wilaya is required";
    if (!address) errors.address = "Address is required";

    return errors;
  };

  const completeFormHandler = () => {
    const validationErrors = validateCompleteForm();

    if (Object.keys(validationErrors).length > 0) {
      console.log(validationErrors);
      setErrors(validationErrors); // Set errors if validation fails
    } else {
      setErrors({});
      // Handle successful form submission here, e.g., save to database or call an API

      submitCartForm();
      console.log("Form submitted successfully:", { phone, wilaya, address });
    }
  };
  const submitCartForm = () => {
    if (currentUser || (phone && address && wilaya)) {
      console.log(initialCartItems);

      var products = [];
      var tot = 0;

      for (let index = 0; index < initialCartItems.length; index++) {
        const element = initialCartItems[index];
        incrNumberSales(element.id);
        products.push({ productId: element.id, quantity: element.quantity });
        tot = tot + parseInt(element.unitPrice) * parseInt(element.quantity);
      }

      console.log(products);
      console.log(currentUser);

      var order = {
        clientId: currentUser ? currentUser.uid : "guest",
        clientName: currentUser ? currentUser.name : guestName,
        clientPhone: phone,
        address: address,
        wilaya: wilaya,
        products: products,
        total: tot,
        date: new Date().toISOString().split("T")[0],
        orderStatus: false,
        paymentStatus: false,
      };

      console.log(order);
      saveOrder(order).then((ref) => {
        console.log("ref saved : " + ref);

        setTimeout(() => {
          setCommandeClickLoading(false);
          setToggleCartOverlay(false);
          setToggleOverlay(false);
          setToggleCompleteInfosOverlay(false);
          setInitialCartItems([]);
          setPhone("");
          setWilaya("");
          setAddress("");
          Swal.fire({
            icon: "success",
            title: "Order placed successfully!",
            html: `<p class="popup-custom-text small-text grey bold">Your order has been placed.</p>`,
            confirmButtonColor: "#fbf008",
            iconColor: "#fbf008",
            confirmButtonText: "Done",
            customClass: {
              popup: "popup",
              icon: "custom-icon",
              container: "popup-container",
              confirmButton: "confirmButton",
              validationMessage: "validationMessage",
              title: "popup-custom-title",
              image: "custom-image",
            },
          });
        }, 2000);
      });
    } else {
      setToggleOverlay(true);
    }
  };

  const selectedVariantData =
    selectedVariant &&
    selectedVariant > 0 &&
    selectedProduct?.varients?.[selectedVariant - 1]
      ? selectedProduct.varients[selectedVariant - 1]
      : null;
  const selectedUnitPrice = Number(
    selectedVariantData?.price ?? selectedProduct?.price ?? 0,
  );

  const inputs = [
    {
      label: "Name",
      name: "name",
      type: "text",
      placeholder: "Enter Your Name Here",
      value: formValues.name,
      onChange: (e) => handleChange(e, "name"),
    },
    {
      label: "Phone",
      name: "phone",
      type: "text",
      placeholder: "Enter Your phone Here",
      value: formValues.phone,
      onChange: (e) => handleChange(e, "phone"),
    },
    {
      label: "Wilaya",
      name: "wilaya",
      type: "select",
      placeholder: "Sélectionnez votre Wilaya",
      options: algeriaWilayas,
      className: "input white wilaya-select",
      value: formValues.wilaya,
      onChange: (e) => handleChange(e, "wilaya"),
    },
    {
      label: "Address",
      name: "address",
      type: "text",
      placeholder: "Enter Your Address Here",
      value: formValues.address,
      onChange: (e) => handleChange(e, "address"),
    },
    {
      label: "Quantity",
      name: "quantity",
      type: "number",
      placeholder: "Enter Your Quantity Here",
      value: formValues.quantity,
      onChange: (e) => handleChange(e, "quantity"),
      min: 1,
      step: 1,
    },
    {
      label: "Total",
      name: "total",
      type: "text",
      placeholder: "Total",
      value: selectedProduct
        ? selectedUnitPrice * Number(formValues.quantity || 0)
        : "",
      disabled: true,
    },
  ];

  /*end Commande Form*/

  /*Search page*/

  const [allProducts, setAllProduct] = useState([]);

  const [minPrice, setMinPrice] = useState("");
  const [maxPrice, setMaxPrice] = useState("");

  // State for the search query
  const [searchQuery, setSearchQuery] = useState("");

  const [selectedBrand, setSelectedBrand] = useState(""); // Default no brand selected
  const [selectedTags, setSelectedTags] = useState([]); // Array of selected tags

  const [allTags, setAllTags] = useState([]);
  const [allBrands, setAllBrands] = useState([]);

  // Category state
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedSubCategory, setSelectedSubCategory] =
    useState("All Subcategories");
  const [categoriesData, setCategoriesData] = useState([]);
  const [availableSubcategories, setAvailableSubcategories] = useState([
    { name: "Toutes les sous-catégories", id: "all" },
  ]);

  const [selectedWeight, setSelectedWeight] = useState("Tous les poids");

  const [allWeight, setAllWeight] = useState([
    "90",
    "100",
    "110",
    "120",
    "130",
    "140",
    "150",
    "250",
    "20000",
  ]);

  const [reviews, setReviews] = useState([
    { client: "Hatem.TM", review: "awsome Product!" },
  ]);

  const [reviewVal, setReviwVal] = useState("");

  const [reviewClickLoading, setReviewClickLoading] = useState(false);

  // Handle tag selection
  const toggleTagSelection = (tag) => {
    if (selectedTags.includes(tag)) {
      setSelectedTags(selectedTags.filter((t) => t !== tag)); // Deselect tag
    } else {
      setSelectedTags([...selectedTags, tag]); // Select tag
    }
  };

  const filteredProducts = allProducts.filter((product) => {
    const productPrice = Number(product.price);

    // Price Range Filter
    const withinPriceRange =
      (minPrice === "" && maxPrice === "") ||
      (minPrice !== "" &&
        maxPrice === "" &&
        productPrice >= Number(minPrice)) ||
      (minPrice === "" &&
        maxPrice !== "" &&
        productPrice <= Number(maxPrice)) ||
      (minPrice !== "" &&
        maxPrice !== "" &&
        productPrice >= Number(minPrice) &&
        productPrice <= Number(maxPrice));

    // Brand Filter
    const matchesBrand =
      !selectedBrand ||
      selectedBrand === "All Brands" ||
      product.brand === selectedBrand;

    // Tags Filter
    const matchesTags =
      selectedTags.length === 0 ||
      selectedTags.every((tag) => product.tags.includes(tag));

    // Search Query Filter
    const matchesSearchQuery = product.name
      .toLowerCase()
      .includes(searchQuery.toLowerCase());

    // Category Filter
    const matchesCategory =
      !selectedCategory || selectedCategory === "All Categories"
        ? true
        : (() => {
            const selectedCategoryObj = categoriesData.find(
              (cat) => cat.categoryName === selectedCategory,
            );
            return selectedCategoryObj
              ? product.category === selectedCategoryObj.id
              : false;
          })();

    // Subcategory Filter
    const matchesSubCategory =
      !selectedSubCategory || selectedSubCategory === "All Subcategories"
        ? true
        : (() => {
            let subcatId = null;
            for (const category of categoriesData) {
              const match = category.subcategories.find(
                (sub) => sub.subcategoryName === selectedSubCategory,
              );
              if (match) {
                subcatId = match.id;
                break;
              }
            }
            return subcatId ? product.subCategory === subcatId : false;
          })();

    // Filter by weight
    const matchesWeight =
      !selectedWeight || selectedWeight === "Tous les poids"
        ? true
        : product.weight != null &&
          product.weight.toString() === selectedWeight.toString();

    // All filters must match
    return (
      withinPriceRange &&
      matchesBrand &&
      matchesTags &&
      matchesSearchQuery &&
      matchesCategory &&
      matchesSubCategory &&
      matchesWeight
    );
  });

  /*end Search page*/

  /* background content*/

  /* end background content*/

  /* cart overlay*/
  const [commandeClickLoading, setCommandeClickLoading] = useState(false);

  const [initialCartItems, setInitialCartItems] = useState([]);
  const addToCart = (product) => {
    console.log(selectedVariant);

    const productId = product.id;
    const variant =
      selectedVariant !== null && selectedVariant > 0
        ? selectedProduct.varients[selectedVariant - 1]
        : null;

    const variantName = variant?.productName || null;

    const variantPrice = variant?.price || null;
    const variantImage = variant?.imagesUrls?.[0] || product.imgSrc?.[0];

    console.log("Variant Name:", variantName);

    // Check if product with same ID and variant name exists
    const existingProduct = initialCartItems.find(
      (item) => item.id === productId && item.variantName === variantName,
    );

    if (existingProduct) {
      const updatedCartItems = initialCartItems.map((item) =>
        item.id === productId && item.variantName === variantName
          ? { ...item, quantity: item.quantity + 1 }
          : item,
      );
      setInitialCartItems(updatedCartItems);
    } else {
      const newProduct = {
        id: productId,
        name: variantName || product.name,
        description: product.description || "",
        unitPrice: variantPrice
          ? parseFloat(variantPrice)
          : parseInt(product.price),
        quantity: 1,
        image: variantImage,
        variantName: variantName, // used for checking uniqueness
        varients: variant || null, // storing full variant info if selected
      };
      setInitialCartItems([...initialCartItems, newProduct]);
    }

    // Clear selection
    if (selectedVariant !== null) setSelectedVariant(null);
  };

  const removeFromCart = (productId, variantName = null) => {
    // Filter out only the matching product + variant combo
    const updatedCartItems = initialCartItems.filter(
      (item) => item.id !== productId || item.variantName !== variantName,
    );

    setInitialCartItems(updatedCartItems);
  };

  /*end cart overlay */

  /*prod details*/
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  useScrollSpy(sectionRefs, setSelectedNavIndex);
  const [recommendedProds, setRecommendedProds] = useState([]);
  const [releventProduct, setReleventProduct] = useState([]);

  const fetchReleventProducts = async () => {
    try {
      const ids = pageContent["relevent-products"].slice(0, 4); // Get first 4 product IDs
      const productPromises = ids.map((id) => getProductById(id));
      const fetchedProducts = await Promise.all(productPromises);

      setReleventProduct(fetchedProducts);
    } catch (error) {
      console.error("Error fetching relevant products:", error);
    }
  };

  useEffect(() => {
    getAllProducts().then((res) => {
      console.log(res);

      if (res) {
        var productList = [];
        var brands = ["All Brands"];
        var recommendedList = []; // New list for recommended products

        for (let index = 0; index < res.length; index++) {
          const element = res[index];

          var pr = {
            id: element.id,
            imgSrc: element.imagesUrls,
            name: element.productName,
            price: element.price,
            brand: element.brandName,
            tags: element.tags,
            reviews: [
              { name: "hatem", rating: 5, comment: "Best product ever" },
            ],
            numberSelles: element.numberSelles,
            varients: element.varients,
            maunalFile: element.maunalFile,
            outOfStock: element.outOfStock,
            subCategory: element.subCategory,
            category: element.category,
            productDescription: element.productDescription,
            weight: element.weight,
            specifications: element.specifications,
          };

          productList.push(pr);

          if (!brands.includes(pr.brand)) {
            brands.push(pr.brand);
          }

          if (element.isRecommended && recommendedList.length < 6) {
            recommendedList.push(pr); // Push to recommended list if true
          }

          setAllProduct(productList);
          setProducts(productList);
          setAllBrands(brands);
          console.log(pr);
        }

        setRecommendedProds(recommendedList); // Set recommended products
      }

      const urlParams = new URLSearchParams(window.location.search);
      const productIdToShow = urlParams.get("productIdToShow");
      console.log("Product ID:", productIdToShow);

      if (productIdToShow !== null) {
        getReviewsById(productIdToShow).then((res) => {
          console.log(res);
          var revs = [];
          for (let index = 0; index < res.length; index++) {
            const element = res[index];
            revs.push({
              client: element.reviewerName,
              review: element.reviewText,
              date: element.createdAt,
              status: element.status,
            });
          }
          setReviews(revs);
        });

        setTimeout(() => {
          const paramProduct = productList.find(
            (product) => product.id === productIdToShow,
          );
          if (paramProduct) {
            console.log(paramProduct);

            setSelectedProduct(paramProduct);
            setToggleDetailOverlay(true);
          }
        }, 2000);
      }
    });

    getActiveContent((data) => {
      setPageContent(data);

      console.log(data);
    });

    getAllCategories().then((data) => {
      setCategoriesData(data);
    });

    getAllTags().then((res) => {
      console.log(res);
      setAllTags(res);
    });
  }, []);

  useEffect(() => {
    if (
      pageContent &&
      pageContent["relevent-products"] &&
      pageContent["relevent-products"].length > 0
    ) {
      fetchReleventProducts();
    }
  }, [pageContent]);

  const [currentBgIndex, setCurrentBgIndex] = useState(0);

  var backgrounds = pageContent?.["home-background"] || [];

  useEffect(() => {
    backgrounds = pageContent?.["home-background"] || [];

    console.log(backgrounds.length + "......................");
    // Do nothing if backgrounds are not ready or empty
    if (!backgrounds || backgrounds.length === 0) return;

    console.log(backgrounds);

    const interval = setInterval(() => {
      setCurrentBgIndex((prev) => (prev + 1) % backgrounds.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [backgrounds]);

  // Update available subcategories when category changes
  useEffect(() => {
    console.log("....");
    if (selectedCategory === "All Categories") {
      setAvailableSubcategories([{ name: "All Subcategories", id: "all" }]);
      if (true) {
        setSelectedSubCategory("All Subcategories");
      }
    } else {
      const category = categoriesData.find(
        (cat) => cat.categoryName === selectedCategory,
      );
      console.log(categoriesData);
      console.log(selectedCategory);
      console.log(category);
      if (category) {
        const subcats = [
          { name: "All Subcategories", id: "all" },
          ...category.subcategories.map((sub) => ({
            name: sub.subcategoryName,
            id: sub.id,
          })),
        ];
        console.log(subcats);
        setAvailableSubcategories(subcats);
        setSelectedSubCategory("All Subcategories");
      }
    }
  }, [selectedCategory, categoriesData]);

  /*
    var order = {client : {clientId : null , clientName: "hatem" , clientPhone:"0552990625" ,clientEmail:"hatem6718@gmail.com" , address:"Centre ville" , wilaya:"Alger"}, products:[{productId:1 , quantity : 2 } , {productId:2 , quantity : 2 }] , total : 2000 , date : "24/10/2024"};
    saveOrder(order).then((res)=> {
      console.log(res);
    })

    */

  useEffect(() => {
    const interval = setInterval(() => {
      if (selectedProduct) {
        setCurrentImageIndex((prevIndex) =>
          prevIndex === selectedProduct.imgSrc.length - 1 ? 0 : prevIndex + 1,
        );
      }
    }, 4000);

    return () => clearInterval(interval); // Clear interval on component unmount
  }, [selectedProduct]);

  useEffect(() => {
    // Listen for auth state changes
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      console.log(currentUser);
      if (currentUser) {
        // Perform any post-login logic, like redirecting to a different page
        const userRef = ref(database, "users/"); // Assuming user data is stored under 'users/{uid}'
        const userSnapshot = await get(userRef);

        if (userSnapshot.exists()) {
          const usersData = userSnapshot.val();
          const foundUser = Object.values(usersData).find(
            (u) => u.uid === currentUser.uid,
          );

          if (foundUser) {
            console.log("User Data:", foundUser);

            currentUser.name = foundUser.lastName;
            currentUser.dataInfos = foundUser;
            currentUser.loginSrc = "email";

            setCurrentUser(currentUser);
            console.log(currentUser);
            console.log("User is logged in:", currentUser);
          } else {
            console.log("User not found in the database!");
          }
        } else {
          console.log("No user data found!");
        }
      } else {
        setCurrentUser(null);
        console.log("No user is logged in");
      }
    });

    // Cleanup listener on unmount
    return () => unsubscribe();
  }, []);

  /*end prod details*/

  /*Side Overlay*/

  const [toggleSideOverlay, setToggleSideOverlay] = useState(false);

  const [toggleFilterSideOverlay, setToggleFilterSideOverlay] = useState(false);

  //Flash Pop Up
  const flashSaleContent = {
    type: "slider",
    items: [prod2, prod3, prod4],
  };
  //end Flash

  function openLinkInNewWindow(url) {
    window.open(url, "_blank", "noopener,noreferrer");
  }

  return isPageLoad ? (
    <div className={`App ${darkMode.value ? "dark-mode" : "light-mode"}`}>
      <motion.div
        className={
          darkMode.value
            ? "dark-mode  loader-container absolute w-full h-full  flex align-items-center justify-center"
            : "light-mode  loader-container absolute w-full h-full  flex align-items-center justify-center"
        }
        initial={{ opacity: 1, scale: 1 }}
        animate={{ opacity: 0, transition: { delay: 3.2 } }}
      >
        <div className="spinner"></div>
      </motion.div>
      <motion.div
        className="content"
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1, transition: { delay: 3.2 } }}
      >
        <Header
          logoImg={logoImg}
          navLinks={navLinks}
          actionText="Se connecter"
          textColor={textColor}
          actionBtnBgColor={actionBtnBgColor}
          btnAction={handleBtnActionClick}
          selectedNavIndex={selectedNavIndex}
          setSelectedNavIndex={setSelectedNavIndex}
          handleNavLinkClick={handleNavLinkClick}
          darkMode={darkMode.value}
          setDarkMode={darkMode}
          animateCart={animateCart}
          currentUser={currentUser}
          logOutHandler={handleLogout}
          iconClickHandler={() => setToggleCartOverlay(true)}
          setToggleSideOverlay={setToggleSideOverlay}
          cartCount={initialCartItems.length}
        />

        <div
          className="section section1 home-section flex align-items-start"
          ref={sectionRefs[0]}
          style={{ position: "relative", overflow: "hidden" }}
        >
          <AnimatePresence mode="wait">
            <motion.div
              key={backgrounds[currentBgIndex]}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 1 }}
              className="background-slide"
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                zIndex: 0,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundImage: `url(${backgrounds[currentBgIndex]})`,
                filter: "brightness(0.6)", // darken the background
              }}
            />
          </AnimatePresence>

          <div className="section-content bold">
            <div className="flex justify-space-between align-items-center rech-div">
              <div className="input-container">
                <input
                  placeholder="Recherceher..."
                  onClick={() => {
                    handleNavLinkClick(2);
                  }}
                />
                <img
                  src={rechIcon}
                  alt=""
                  className="absolute right0 small-icon"
                />
              </div>
            </div>
            <div className="flex-column  main-text-container">
              <p>Site Web E-commerce SportsGate</p>
              <p className="small-text my-10">
                Bienvenue chez Sports Gate, votre partenaire incontournable pour
                des équipements de sport et de fitness haut de gamme. Donnez vie
                à vos objectifs avec du matériel performant, un service expert
                et une passion au cœur de chaque mouvement.
              </p>
            </div>

            <div></div>
            <motion.div
              className="home-imgs-galery flex justify-center align-center "
              animate={
                window.innerWidth <= 468
                  ? {
                      x: ["0%", "40%", "-40%"],
                      transition: {
                        x: {
                          repeat: Infinity,
                          repeatType: "reverse",
                          duration: 9,
                          delay: 4.5,
                        },
                      },
                    }
                  : {
                      x: ["0%", "-10%", "10%"],
                      transition: {
                        x: {
                          repeat: Infinity,
                          repeatType: "reverse",
                          duration: 5,
                          delay: 4.5,
                        },
                      },
                    }
              }
            >
              {releventProduct.length > 0 &&
                (() => {
                  const images = [];

                  // Collect up to 7 image URLs from the fetched products
                  for (const product of releventProduct) {
                    if (
                      product &&
                      product.imagesUrls &&
                      Array.isArray(product.imagesUrls)
                    ) {
                      for (const imgUrl of product.imagesUrls) {
                        if (images.length < 7) {
                          images.push(imgUrl);
                        } else {
                          break;
                        }
                      }
                    }
                    if (images.length >= 7) break;
                  }

                  return images.map((img, index) => (
                    <div
                      key={index}
                      className="home-img flex align-items-center justify-center border-radius"
                    >
                      <img src={img} alt={`relevant-${index}`} />
                    </div>
                  ));
                })()}
            </motion.div>

            <div className="home-end flex-column justify-space-evenly align-items-center absolute  full-width bottom0 left0">
              <motion.div
                className="full-width  relative home-end-content1"
                initial={{ opacity: 0, left: "100px" }}
                animate={{
                  opacity: 1,
                  left: "0px",
                  transition: { delay: 3.5 },
                }}
              >
                <div className="flex-column full-width">
                  <p>
                    Plus de <span className="red">300</span> Produits
                  </p>
                  <p className="small-text grey">Plus de 20 Marques</p>
                </div>

                <div className="my-20 flex brands-imgs full-width">
                  <img
                    src={logo}
                    alt=""
                    className={
                      darkMode.value
                        ? " logo-img pointer "
                        : " logo-img pointer "
                    }
                  />
                  <img
                    src={logo2}
                    alt=""
                    className={
                      darkMode.value
                        ? " logo-img pointer "
                        : " logo-img pointer "
                    }
                  />
                  <img
                    src={logo3}
                    alt=""
                    className={
                      darkMode.value
                        ? " logo-img pointer "
                        : " logo-img pointer "
                    }
                  />
                </div>

                <div className=" absolute top0 right0 left-infos flex-column align-items-end">
                  <p>
                    Plus de <span className="red">658</span> Clients
                  </p>

                  <p className="small-text grey">Plus de 258 avis</p>
                  <motion.div
                    className="action-button  bottom0 right0"
                    initial={{
                      actionBtnBgColor: "#fbf008",
                      color: darkMode ? "black" : "white",
                    }}
                    animate={{
                      backgroundColor: "#fbf008",
                      color: darkMode ? "white" : "white",
                    }}
                    transition={{ duration: 0.3, ease: "easeInOut" }}
                    onClick={() => {
                      handleNavLinkClick(3);
                    }}
                  >
                    <p className="btn">Voir les Produits</p>
                  </motion.div>
                </div>
              </motion.div>

              <div className="arrowdown full-width align-items-center justify-center bottom-action">
                <motion.img
                  src={arrowDown}
                  alt=""
                  className={
                    darkMode.value
                      ? "logo-img pointer grayscale-image100"
                      : "logo-img pointer"
                  }
                  onClick={() => handleNavLinkClick(1)}
                  initial={{ bottom: "-100px", opacity: 0 }}
                  animate={{
                    bottom: "25px",
                    opacity: 1,
                    transition: { delay: 4 },
                  }}
                />
              </div>
            </div>
          </div>
        </div>

        <CategoriesSection
          setSelectedCategory={setSelectedCategory}
          setSelectedSubCategory={setSelectedSubCategory}
          scrollIntoView={handleNavLinkClick}
          sectionRef={sectionRefs[1]}
        />

        <div
          className="section section2 home-section flex-column align-items-start products-page bold"
          ref={sectionRefs[2]}
        >
          <div
            className={
              darkMode.value
                ? "dark-mode absolute back-text"
                : " absolute back-text"
            }
          >
            <p className="">Matériel Sportif</p>
          </div>
          <div className="flex justify-space-between align-items-center main-text-container">
            <p>Produits Recommandés</p>
          </div>
          <div className="home-imgs-galery  flex justify-center align-center my-20">
            {recommendedProds.map((product) => (
              <motion.div
                key={product.id}
                className="home-img  flex-column align-items-center justify-center border-radius relative"
                animate={
                  hoveredProduct === product.id
                    ? {
                        width:
                          hoveredProduct === product.id
                            ? window.innerWidth <= 468
                              ? "90vw"
                              : "30vw"
                            : "auto",
                      }
                    : {}
                }
                onClick={() => {
                  window.innerWidth <= 468 && setHoveredProduct(product.id);
                }}
                onMouseEnter={() =>
                  !(window.innerWidth <= 468) && setHoveredProduct(product.id)
                }
                onMouseLeave={() =>
                  !window.innerWidth <= 468 && setHoveredProduct(null)
                }
              >
                {/* Product Image and Basic Info */}
                <div className="full-width basic-info card-content  flex-column justify-end align-items-center">
                  {!product.outOfStock && (
                    <div className="stock-tag absolute top0 left0 white px-10 py-5 small-text border-radius-5 z-2">
                      En rupture
                    </div>
                  )}
                  <img src={product.imgSrc[0]} alt={product.name} />

                  <div className="flex flex-column align-items-center justify-center">
                    <p>{product.name}</p>
                    <div className="action-button bg-white black my-10 price-btn">
                      <p className="btn black">{product.price} DA</p>
                    </div>
                  </div>
                </div>

                {/* Hidden Detail Section */}
                <motion.div
                  className="absolute full-height top0 right0 flex-column align-items-center justify-center card-hidden-info"
                  initial={{ opacity: 0, right: "-100px" }}
                  animate={
                    hoveredProduct === product.id
                      ? {
                          opacity: 1,
                          right: "0px",
                          transition: { delay: 0.1 },
                        }
                      : { opacity: 0, right: "-100px" }
                  }
                >
                  <p className="small-text grey">{product.brand}</p>
                  <p>{product.name}</p>
                  <div className="flex align-items-center">
                    <motion.div
                      className="action-button my-10 mx-5"
                      initial={{
                        actionBtnBgColor: "#fbf008",
                        color: darkMode ? "black" : "white",
                        opacity: !product.outOfStock ? 0.5 : 1,
                        pointerEvents: !product.outOfStock ? "none" : "auto",
                      }}
                      animate={{
                        backgroundColor: "#fbf008",
                        color: darkMode ? "white" : "white",
                        opacity: !product.outOfStock ? 0.5 : 1,
                      }}
                      transition={{ duration: 0.3, ease: "easeInOut" }}
                      onClick={() => {
                        if (product.outOfStock) {
                          setToggleProductOverlay(true);
                          handleBuyClick(product);
                        }
                      }}
                    >
                      <p className="btn">Acheter</p>
                    </motion.div>

                    <motion.div
                      className="action-button mx-5"
                      initial={{
                        actionBtnBgColor: "#fbf008",
                        color: darkMode ? "black" : "white",
                      }}
                      animate={{
                        backgroundColor: "#fbf008",
                        color: darkMode ? "white" : "white",
                      }}
                      transition={{ duration: 0.3, ease: "easeInOut" }}
                      onClick={() => {
                        setToggleDetailOverlay(true);
                        handleBuyClick(product);
                      }}
                    >
                      <p className="btn">Infos</p>
                    </motion.div>
                  </div>
                  <motion.div
                    className="action-button bg-red my-10 fit-content"
                    initial={{
                      opacity: !product.outOfStock ? 0.5 : 1,
                      pointerEvents: !product.outOfStock ? "none" : "auto",
                    }}
                    animate={{
                      opacity: !product.outOfStock ? 0.5 : 1,
                    }}
                    onClick={() => {
                      if (product.outOfStock) {
                        setAnimateCart(true);
                        setTimeout(() => setAnimateCart(false), 200);
                        addToCart(product, selectedVariant);
                      }
                    }}
                  >
                    <p className="btn">Ajouter au panier</p>
                  </motion.div>
                </motion.div>
              </motion.div>
            ))}
          </div>

          <div className="flex justify-space-between align-items-center main-text-container">
            <p>Produits les Plus Vendus</p>
          </div>

          <div className="home-imgs-galery flex justify-center align-center my-20  top-gallry">
            {recommendedProds.map((product) => (
              <motion.div
                key={product.id + "100"}
                className="home-img flex-column align-items-center justify-center border-radius relative"
                animate={
                  hoveredProduct === product.id + "100"
                    ? { width: window.innerWidth <= 468 ? "90vw" : "30vw" }
                    : {}
                }
                onClick={() => {
                  window.innerWidth <= 468 &&
                    setHoveredProduct(product.id + "100");
                }}
                onMouseEnter={() =>
                  !(window.innerWidth <= 468) &&
                  setHoveredProduct(product.id + "100")
                }
                onMouseLeave={() =>
                  !window.innerWidth <= 468 && setHoveredProduct(null)
                }
              >
                {/* Product Image and Basic Info */}
                <div className="full-width basic-info card-content  flex-column justify-end align-items-center">
                  {!product.outOfStock && (
                    <div className="stock-tag absolute top0 left0 white px-10 py-5 small-text border-radius-5 z-2">
                      En rupture
                    </div>
                  )}
                  <img src={product.imgSrc[0]} alt={product.name} />
                  <div className="flex flex-column align-items-center justify-center">
                    <p>{product.name}</p>
                    <div className="action-button bg-white black my-10 price-btn">
                      <p className="btn black">{product.price} DA</p>
                    </div>
                  </div>
                </div>

                {/* Hidden Detail Section */}
                <motion.div
                  className="absolute full-height top0 right0 flex-column align-items-center justify-center card-hidden-info"
                  initial={{ opacity: 0, right: "-100px" }}
                  animate={
                    hoveredProduct === product.id + "100"
                      ? {
                          opacity: 1,
                          right: "0px",
                          transition: { delay: 0.1 },
                        }
                      : { opacity: 0, right: "-100px" }
                  }
                >
                  <p className="small-text grey">{product.brand}</p>
                  <p>{product.name}</p>

                  {/* Action Buttons */}
                  <div className="flex align-items-center">
                    <motion.div
                      className="action-button my-10 mx-5"
                      initial={{
                        actionBtnBgColor: "#fbf008",
                        color: darkMode ? "black" : "white",
                        opacity: !product.outOfStock ? 0.5 : 1,
                        pointerEvents: !product.outOfStock ? "none" : "auto",
                      }}
                      animate={{
                        backgroundColor: "#fbf008",
                        color: darkMode ? "white" : "white",
                        opacity: !product.outOfStock ? 0.5 : 1,
                      }}
                      transition={{ duration: 0.3, ease: "easeInOut" }}
                      onClick={() => {
                        if (product.outOfStock) {
                          setToggleProductOverlay(true);
                          handleBuyClick(product);
                        }
                      }}
                    >
                      <p className="btn">Acheter</p>
                    </motion.div>

                    <motion.div
                      className="action-button mx-5"
                      initial={{
                        actionBtnBgColor: "#fbf008",
                        color: darkMode ? "black" : "white",
                      }}
                      animate={{
                        backgroundColor: "#fbf008",
                        color: darkMode ? "white" : "white",
                      }}
                      transition={{ duration: 0.3, ease: "easeInOut" }}
                      onClick={() => {
                        setToggleDetailOverlay(true);
                        handleBuyClick(product);
                      }}
                    >
                      <p className="btn">Infos</p>
                    </motion.div>
                  </div>
                  <motion.div
                    className="action-button bg-red my-10 fit-content"
                    initial={{
                      opacity: !product.outOfStock ? 0.5 : 1,
                      pointerEvents: !product.outOfStock ? "none" : "auto",
                    }}
                    animate={{
                      opacity: !product.outOfStock ? 0.5 : 1,
                    }}
                    onClick={() => {
                      if (product.outOfStock) {
                        setAnimateCart(true);
                        setTimeout(() => setAnimateCart(false), 200);
                        addToCart(product, selectedVariant);
                      }
                    }}
                  >
                    <p className="btn">Ajouter au panier</p>
                  </motion.div>
                </motion.div>
              </motion.div>
            ))}{" "}
          </div>
        </div>

        <div
          className="section section3 products-section flex align-items-start bold"
          ref={sectionRefs[3]}
        >
          <motion.div className="filters-container bold absolute h-full top0 left0">
            <p>Filtre</p>
            <div className="filter-container">
              <p className="grey small-text ">Marque</p>
              <div className="filter-options">
                <SelectOption
                  options={allBrands}
                  onOptionSelect={setSelectedBrand}
                  textColor={"black"}
                  selectedOption={selectedBrand}
                  lamp
                  belBgColor={"#6363630d"}
                  externalSelectedOption={null}
                />
              </div>
            </div>

            {/* Category Filter */}
            <div className="filter-container">
              <p className="grey small-text my-10">Catégorie</p>
              <div className="filter-options">
                <SelectOption
                  options={[
                    "All Categories",
                    ...categoriesData.map((category) => category.categoryName),
                  ]}
                  onOptionSelect={setSelectedCategory}
                  externalSelectedOption={selectedCategory}
                  labelBgColor={"#6363630d"}
                />
              </div>
            </div>

            {/* Subcategory Filter */}
            <div className="filter-container">
              <p className="grey small-text my-10">Sous-catégorie</p>
              <div className="filter-options">
                <SelectOption
                  options={availableSubcategories.map((sub) => sub.name)}
                  optionValues={availableSubcategories.map((sub) => sub.id)}
                  onOptionSelect={setSelectedSubCategory}
                  labelBgColor={"#6363630d"}
                  externalSelectedOption={selectedSubCategory}
                />
              </div>
            </div>

            <div className="filter-container">
              <p className="grey small-text my-10">Poids</p>
              <div className="filter-options">
                <SelectOption
                  options={["Tous les poids", ...allWeight]}
                  optionValues={["Tous les poids", ...allWeight]}
                  onOptionSelect={setSelectedWeight}
                  labelBgColor={"#6363630d"}
                  selectedValue={selectedWeight}
                />
              </div>
            </div>

            <div className="filter-container">
              <p className="grey small-text my-10">Étiquettes</p>
              <div className="filter-options grid-filter-options">
                {allTags.map((tag, index) => {
                  return (
                    <motion.div
                      className="filter tag"
                      initial={
                        darkMode.value
                          ? { backgroundColor: "#595252", color: "#9babb8" }
                          : { backgroundColor: "#fff", color: "#9babb8" }
                      }
                      animate={
                        selectedTags.includes(tag)
                          ? { backgroundColor: "#fbf008", color: "white" }
                          : !darkMode.value
                            ? { backgroundColor: "white", color: "#9babb8" }
                            : {
                                backgroundColor: "transparent",
                                color: "#9babb8",
                              }
                      }
                      onClick={() => toggleTagSelection(tag)}
                    >
                      <p>{tag}</p>
                    </motion.div>
                  );
                })}
              </div>
            </div>

            <div className="filter-container">
              <p className="grey small-text my-10">Prix</p>
              <div className="filter-options">
                <input
                  type="text"
                  placeholder="Prix Min"
                  value={minPrice}
                  onChange={(e) => setMinPrice(e.target.value)}
                />

                <input
                  type="text"
                  placeholder="Prix Max"
                  className="my-10"
                  value={maxPrice}
                  onChange={(e) => setMaxPrice(e.target.value)}
                />
              </div>
            </div>
          </motion.div>

          <div className="flex justify-space-between align-items-center rech-div">
            <div className="input-container">
              <input
                placeholder="Rechercher..."
                value={searchQuery}
                onChange={(e) => {
                  setSearchQuery(e.target.value);
                }}
              />
              <img
                src={rechIcon}
                alt=""
                className="absolute right0 small-icon"
                // Update searchQuery when input changes
              />
            </div>
            <img
              src={filter}
              alt=""
              className={
                darkMode.value
                  ? " inverted-image logo-img pointer filter-img"
                  : "logo-img pointer filter-img"
              }
              onClick={() => {
                setToggleFilterSideOverlay(true);
              }}
            />
          </div>

          <div className="products-grid">
            {filteredProducts && filteredProducts.length > 0 ? (
              filteredProducts.map((product, index) => (
                <motion.div className="">
                  <motion.div
                    className="relative "
                    key={`${product.id}-${searchQuery}`} // Dynamic key to trigger animation on search
                    initial={{ opacity: 0, y: 20 }} // Start with 0 opacity and slight y translation
                    animate={{ opacity: 1, y: 0 }} // Animate to full opacity and y=0
                    exit={{ opacity: 0, y: 20 }} // Exit with same transition when removed
                    // Short animation duration
                  >
                    <motion.div
                      className="home-img flex-column align-items-center justify-space-between  border-radius"
                      onClick={() => {
                        setSelectedProduct(product);
                        getReviewsById(product.id).then((res) => {
                          console.log(res);
                          var revs = [];
                          for (let index = 0; index < res.length; index++) {
                            const element = res[index];
                            revs.push({
                              client: element.reviewerName,
                              review: element.reviewText,
                              date: element.createdAt,
                              status: element.status,
                            });
                          }
                          setReviews(revs);

                          setTimeout(() => {
                            setToggleDetailOverlay(true);
                          }, 500);
                        });
                      }}
                    >
                      {!product.outOfStock && (
                        <div className="stock-tag absolute top0 left0 white px-10 py-5 small-text border-radius-5 z-2">
                          En rupture
                        </div>
                      )}

                      {/* Animate the image */}
                      <motion.img
                        src={product.imgSrc ? product.imgSrc[0] : null}
                        alt={product.name}
                        initial={{ opacity: 0, y: 20 }} // Start slightly below and invisible
                        animate={{ opacity: 1, y: 0 }} // Fade in and move up
                        transition={{ delay: 0.5 + index * 0.05 }} // Delay based on the product index
                        style={{ zIndex: 1 }}
                      />
                      {/* Animate the product name */}

                      <div>
                        <motion.p
                          className="small-text grey my-5"
                          initial={{ opacity: 0, y: 20 }}
                          animate={{ opacity: 1, y: 0 }}
                          transition={{ delay: index * 0.05 }} // Delay even more
                        >
                          {product.brand}
                        </motion.p>

                        <motion.p
                          initial={{ opacity: 0, y: 20 }}
                          animate={{ opacity: 1, y: 0 }}
                          transition={{ delay: index * 0.05 }} // Delay slightly more than image
                          style={{ zIndex: 1 }}
                        >
                          {product.name}
                        </motion.p>
                        {/* Animate the product price */}

                        <motion.p
                          className="red my-5  flex align-items-center justify-center price-tag"
                          initial={{ opacity: 0, y: 20 }}
                          animate={{ opacity: 1, y: 0 }}
                          style={{ zIndex: 1 }}
                          transition={{ delay: index * 0.05 }} // Delay even more
                        >
                          <div className="action-button bg-white black my-10 price-btn">
                            <p className="btn black">{product.price} DA</p>
                          </div>
                        </motion.p>
                      </div>

                      {/*
                        <img
                        className="small-icon mx-10 pointer"
                        src={add}
                        alt="Add to cart"
                        onClick={() => {
                          setAnimateCart(true);
                          setTimeout(() => setAnimateCart(false), 200);
                          addToCart(product);
                      }}
                    />
                      */}
                    </motion.div>
                  </motion.div>
                </motion.div>
              ))
            ) : (
              <p>Aucun produit trouvé</p>
            )}
          </div>
        </div>

        <div
          className="section section4 home-section about-section flex align-items-start"
          ref={sectionRefs[4]}
        >
          <div className="white bold black-overlay h-full w-full absolute flex-column align-items-center justify-center">
            <p className="main-text">
              Pourquoi choisir <span>Sports Gate?</span>
            </p>
            <p className="small-text my-20">
              Chez Sports Gate, nous ne vendons pas seulement du matériel – nous
              construisons votre réussite sportive. Grâce à notre sélection
              rigoureuse, notre expertise passionnée et notre service client
              dédié, chaque achat devient un pas de plus vers vos objectifs.
            </p>

            <div className="about-items flex justify-center align-items-center my-20 f-width ">
              <div className="about-item ">
                <p className="main-text">1</p>
                <div className="fit-content-hr"></div>
                <p className="small-text my-10">
                  {" "}
                  Qualité premium : Des marques reconnues et du matériel fiable.
                </p>
              </div>

              <div className="about-item ">
                <p className="main-text">2</p>
                <div className="fit-content-hr"></div>
                <p className="small-text my-10">
                  Conseil personnalisé: Une équipe experte à votre écoute.
                </p>
              </div>

              <div className="about-item ">
                <p className="main-text">3</p>
                <div className="fit-content-hr"></div>
                <p className="small-text my-10">
                  Livraison rapide: Où que vous soyez, on vous
                  équipe sans attendre.
                </p>
              </div>
            </div>
          </div>
        </div>

        <AfterSalesServiceSection ref={sectionRefs[5]} />

        <div
          className="dark- section section5 bold home-section flex-column align-items-center justify-center"
          ref={sectionRefs[6]}
        >
          <img
            alt=""
            src={logoImg}
            className={
              darkMode.value
                ? "inverted-image logo-img sportsgate-logo"
                : "logo-img sportsgate-logo"
            }
          />
          <p className="sec-text">Contactez Notre Équipe Amicale !</p>
          <p className="small-text grey ">
            Vous trouverez tout ce dont vous avez besoin pour obtenir du soutien
            dans cette section
          </p>

          <div className="flex my-40 contact-divs">
            <div className="flex-column justify-space-between mx-20 p-10 contact-div border-radius-5">
              <div className="">
                <img
                  alt=""
                  src={contact1}
                  className={
                    darkMode.value ? "inverted-image logo-img" : "logo-img"
                  }
                />
              </div>
              <div>
                <p className=" my-5">Discuter avec le Support</p>
                <p className="small-text grey">
                  Contactez-nous si vous avez besoin d'informations de support
                </p>
                <div className="full-width-hr"></div>
                <p className="small-text underline">Sports.gate.dz@gmail.com</p>
              </div>
            </div>

            <div className="flex-column justify-space-between mx-20 p-10 contact-div border-radius-5">
              <div className="">
                <img
                  alt=""
                  src={contact2}
                  className={
                    darkMode.value ? "inverted-image logo-img " : "logo-img"
                  }
                />
              </div>
              <div>
                <p className=" my-5">Media</p>
                <p className="small-text grey ">
                  Contactez-nous si vous avez besoin d'informations de support
                </p>
                <div className="full-width-hr"></div>
                <p
                  className="small-text underline pointer"
                  onClick={() => {
                    openLinkInNewWindow(
                      pageContent && pageContent["contact-info"]
                        ? pageContent["contact-info"]["youtube"]
                        : null,
                    );
                  }}
                >
                  Voir Notre Chaine
                </p>
              </div>
            </div>

            <div className="flex-column justify-space-between mx-20 p-10 contact-div border-radius-5">
              <div className="">
                <img
                  alt=""
                  src={contact3}
                  className={
                    darkMode.value ? "inverted-image logo-img" : "logo-img"
                  }
                />
              </div>
              <div>
                <p className=" my-5">Localisation</p>
                <p className="small-text grey ">
                  Contactez-nous si vous avez besoin d'informations de support
                </p>
                <div className="full-width-hr"></div>
                <p
                  className="small-text underline pointer"
                  onClick={() => {
                    openLinkInNewWindow(
                      "https://share.google/JgcRril3Evv0dxDjU",
                    );
                  }}
                >
                  Voir Sur Maps
                </p>
              </div>
            </div>

            <div className="flex-column justify-space-between mx-20 p-10 contact-div border-radius-5">
              <div className="">
                <img
                  alt=""
                  src={contact4}
                  className={
                    darkMode.value ? "inverted-image logo-img" : "logo-img"
                  }
                />
              </div>
              <div>
                <p className=" my-5">Téléphone</p>
                <p className="small-text grey ">
                  Contactez-nous si vous avez besoin d'informations de support
                </p>
                <div className="full-width-hr"></div>
                <p className="small-text underline">0553700837</p>
              </div>
            </div>
          </div>

          <div className="flex-column w-full contact-end">
            <div className="flex align-items-center">
              <img
                alt=""
                src={logoImg}
                className={
                  darkMode.value
                    ? "inverted-image logo-img sportsgate-logo"
                    : "logo-img sportsgate-logo"
                }
              />
            </div>

            <p className="small-text grey my-20 w-50">
              Vous trouverez tout ce dont vous avez besoin pour obtenir du
              soutien dans cette section.
            </p>
            <div className="flex w-full justify-space-between align-items-center">
              <p className="small-text">
                @ SportGates. Tous les droits sont réservés
              </p>
              <div className="flex">
                <img
                  alt=""
                  src={fb}
                  className={
                    darkMode.value
                      ? "logo-img mx-10 pointer"
                      : "inverted-image logo-img mx-10 pointer"
                  }
                  onClick={(e) => {
                    openLinkInNewWindow(
                      "https://www.facebook.com/share/1iX1ptdivV/",
                    );
                  }}
                />
                <img
                  alt=""
                  src={insta}
                  className={
                    darkMode.value
                      ? "logo-img mx-10 pointer"
                      : "inverted-image logo-img mx-10 pointer"
                  }
                  onClick={(e) => {
                    openLinkInNewWindow(
                      "https://www.instagram.com/sports.gate.dz?igsh=MWcxNDBvZ3YyeXNpbg==",
                    );
                  }}
                />
                <img
                  alt=""
                  src={tiktok}
                  className={
                    darkMode.value
                      ? "logo-img mx-10 pointer"
                      : "inverted-image logo-img mx-10 pointer"
                  }
                  onClick={(e) => {
                    openLinkInNewWindow(
                      "https://www.tiktok.com/@sports.gate.dz?_r=1&_t=ZS-92bER4JzeKK",
                    );
                  }}
                />
              </div>
            </div>
          </div>
        </div>

        <OverlayContainer
          contentHeight="90%"
          contentWidth="90%"
          darkMode={darkMode.value}
          toggleOverlay={() => setToggleDetailOverlay(false)}
          stat={toggleDetailOverlay}
          children={
            selectedProduct ? (
              <div className=" w-full h-full detailsOverlayScroll">
                <motion.div
                  className={
                    darkMode.value
                      ? "dark-mode top0 left0 product-overlay-loader bg-white full-width h-full flex align-items-center justify-center absolute"
                      : "light-mode top0 left0 product-overlay-loader bg-white full-width h-full flex align-items-center justify-center absolute"
                  }
                  initial={{ opacity: 1 }}
                  animate={{ opacity: 0 }}
                  transition={{ delay: 0.5 }}
                >
                  <div className="spinner"></div>
                </motion.div>
                <div className="flex flex-column product-details-container product-details-content">
                  <motion.div
                    className="content  product-details-container details-left w-full h-full bold"
                    initial={{ opacity: 0, scale: 1.2 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ delay: 0.8 }}
                  >
                    <img
                      alt=""
                      src={logoImg}
                      className={
                        darkMode.value
                          ? "inverted-image logo-img sportsgate-logo"
                          : "logo-img sportsgate-logo"
                      }
                    />
                    <div className="my-20">
                      <p>Détails du produit</p>
                      <p className="small-text grey">Produit SportGates.</p>
                    </div>

                    <div className="my-20 w-full border-radius-5  prodcut-details-img-container flex align-items-center justify-center">
                      <div className="slider-img-container relative">
                        <AnimatePresence initial={false} mode="wait">
                          <motion.img
                            key={selectedProduct.imgSrc[currentImageIndex]}
                            src={
                              selectedVariant
                                ? selectedProduct.varients[selectedVariant - 1]
                                    .imagesUrls[0]
                                : selectedProduct.imgSrc[currentImageIndex]
                            }
                            alt={"prod img"}
                            className="z-2 img200 prod-slider-img"
                            initial={{ opacity: 0, scale: 0.8 }} // Initial state before animation
                            animate={{ opacity: 1, scale: 1 }} // Animate to this state
                            exit={{ opacity: 0, scale: 0.8 }} // Exit animation
                          />
                        </AnimatePresence>
                      </div>
                    </div>
                    <div className="my-20 prod-desc">
                      <p>
                        Produit :{" "}
                        <span className="grey">
                          {selectedVariant
                            ? selectedProduct.varients[selectedVariant - 1]
                                .productName
                            : selectedProduct.name}
                        </span>
                      </p>

                      {(selectedVariant &&
                        !selectedProduct.varients[selectedVariant - 1]
                          .outOfStock) ||
                      !selectedProduct.outOfStock ? (
                        <div className="stock-tag my-20 fit-content  white px-10 py-5 small-text border-radius-5 z-2">
                          En rupture
                        </div>
                      ) : null}

                      <p>Description</p>
                      <p className="small-text grey my-10 ">
                        {selectedVariant
                          ? selectedProduct.varients[selectedVariant - 1]
                              .productDescription
                          : selectedProduct.productDescription}
                      </p>
                      {/* Specifications */}
                      {(selectedVariant
                        ? selectedProduct.varients[selectedVariant - 1]
                            .specifications
                        : selectedProduct.specifications) && (
                        <div className="my-10">
                          <p>Spécifications</p>
                          <p className="small-text grey my-10">
                            {Array.isArray(
                              selectedVariant
                                ? selectedProduct.varients[selectedVariant - 1]
                                    .specifications
                                : selectedProduct.specifications,
                            )
                              ? (selectedVariant
                                  ? selectedProduct.varients[
                                      selectedVariant - 1
                                    ].specifications
                                  : selectedProduct.specifications
                                ).join(", ")
                              : selectedVariant
                                ? selectedProduct.varients[selectedVariant - 1]
                                    .specifications
                                : selectedProduct.specifications}
                          </p>
                        </div>
                      )}
                    </div>

                    <div className="my-20">
                      <p>Avis Client</p>

                      <div className="reviews-container  my-10 flex align-items-center">
                        
                        {reviews.length === 0 ? (
                          <div className="review-container relative px-10 py-10 box-sizing bg- border-radius-5 mr-10">
                            <p className="small-text"></p>
                            <p className="grey small-text center-text absolute">
                              ' Pas encore d avis '
                            </p>
                          </div>

                          
                        ) : (
                          reviews.map((review) => {
                            return (
                              review.status && (
                                <div className="review-container relative px-10 py-10 box-sizing bg- border-radius-5 mr-10">
                                  <p className="small-text">
                                    {review.client} <br />
                                    <span className="grey smaller-text">
                                      {review.date}
                                    </span>
                                  </p>

                                  <p className="grey small-text center-text absolute">
                                    ' {review.review} '
                                  </p>
                                </div>
                              )
                            );
                          })

                          
                        )}
                      </div>

                      <div className="w-full  my-20">
                        <div className="flex align-items-center justify-space-between  overlay-btns-container">
                          <motion.div
                            className="action-button my-10 mx-5"
                            initial={{
                              actionBtnBgColor: "#fbf008",
                              color: darkMode ? "black" : "white",
                            }}
                            animate={{
                              backgroundColor: "rgba(99, 99, 99, 0.4)",
                              color: darkMode ? "white" : "white",
                            }}
                            transition={{ duration: 0.3, ease: "easeInOut" }}
                            onClick={() => {
                              if (currentUser) {
                                setToggleReviewOverlay(true);
                              } else {
                                setToggleOverlay(true);
                              }
                            }}
                          >
                            <p className="btn">Ajouter un Avis</p>
                          </motion.div>

                          <div className="flex align-items-center">
                            <motion.div
                              className="action-button mx-5"
                              initial={{
                                actionBtnBgColor: "#fbf008",
                                color: darkMode ? "black" : "white",
                                opacity: (
                                  selectedVariant
                                    ? selectedProduct.varients?.[
                                        selectedVariant - 1
                                      ]?.outOfStock
                                    : selectedProduct.outOfStock
                                )
                                  ? 1
                                  : 0.5,
                                pointerEvents: (
                                  selectedVariant
                                    ? selectedProduct.varients?.[
                                        selectedVariant - 1
                                      ]?.outOfStock
                                    : selectedProduct.outOfStock
                                )
                                  ? "auto"
                                  : "none",
                              }}
                              animate={{
                                backgroundColor: "#fbf008",
                                color: darkMode ? "white" : "white",
                                opacity: (
                                  selectedVariant
                                    ? selectedProduct.varients?.[
                                        selectedVariant - 1
                                      ]?.outOfStock
                                    : selectedProduct.outOfStock
                                )
                                  ? 1
                                  : 0.5,
                              }}
                              transition={{ duration: 0.3, ease: "easeInOut" }}
                              onClick={() => {
                                if (
                                  selectedVariant
                                    ? selectedProduct.varients?.[
                                        selectedVariant - 1
                                      ]?.outOfStock
                                    : selectedProduct.outOfStock
                                ) {
                                  setAnimateCart(true);
                                  setTimeout(() => setAnimateCart(false), 200);
                                  addToCart(selectedProduct);
                                }
                              }}
                            >
                              <p className="btn">Ajouter au Panier</p>
                            </motion.div>
                            <motion.div
                              className="action-button mx-5"
                              initial={{
                                actionBtnBgColor: "#fbf008",
                                color: darkMode ? "black" : "white",
                                opacity: !selectedProduct.outOfStock ? 0.5 : 1,
                                pointerEvents: !selectedProduct.outOfStock
                                  ? "none"
                                  : "auto",
                              }}
                              animate={{
                                backgroundColor: "#fbf008",
                                color: darkMode ? "white" : "white",
                                opacity:
                                  selectedVariant &&
                                  !selectedProduct.varients[selectedVariant - 1]
                                    .outOfStock
                                    ? 0.5
                                    : !selectedProduct.outOfStock
                                      ? 0.5
                                      : 1,
                              }}
                              transition={{ duration: 0.3, ease: "easeInOut" }}
                              onClick={() => {
                                if (selectedVariant) {
                                  if (
                                    selectedProduct.varients[
                                      selectedVariant - 1
                                    ].outOfStock
                                  ) {
                                    setToggleProductOverlay(true);
                                  }
                                } else {
                                  if (selectedProduct.outOfStock) {
                                    setToggleProductOverlay(true);
                                  }
                                }
                              }}
                            >
                              <p className="btn">Commander Maintenant</p>
                            </motion.div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </motion.div>

                  <div className="details-right bold">
                    <ProductDetailsTabs
                      product={selectedProduct}
                      darkMode={darkMode.value}
                      setSelectedVariant={setSelectedVariant}
                    />
                  </div>
                </div>
              </div>
            ) : null
          }
        />

        <OverlayContainer
          contentHeight="30%"
          contentWidth="55%"
          darkMode={darkMode.value}
          className={"review-overlay"}
          toggleOverlay={() => setToggleReviewOverlay(false)}
          stat={toggleReviewOverlay}
          children={
            <div className=" review-form">
              <div>
                <motion.div
                  className={
                    darkMode.value
                      ? "dark-mode top0 left0 product-overlay-loader bg-white full-width h-full flex align-items-center justify-center absolute"
                      : "top0 left0 product-overlay-loader bg-white full-width h-full flex align-items-center justify-center absolute"
                  }
                  initial={{ opacity: 1 }}
                  animate={{ opacity: 0 }}
                  transition={{ delay: 0.8 }}
                >
                  <div className="spinner"></div>
                </motion.div>
                <motion.div
                  initial={{ opacity: 0, scale: 1.2 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{ delay: 0.9 }}
                  className="bold review-form-content"
                >
                  <img
                    alt=""
                    src={logoImg}
                    className={
                      darkMode.value
                        ? "inverted-image logo-img sportsgate-logo"
                        : "logo-img sportsgate-logo"
                    }
                  />

                  <div className="flex justify-space-between w-full">
                    <div className="my-20 review-left">
                      <p>Avis sur le produit</p>
                      <p className="small-text grey">SportGates.</p>
                    </div>

                    <div className="w-full">
                      <div className="input-container relative">
                        <textarea
                          placeholder="Votre avis..."
                          className={
                            darkMode.value ? "white input" : "black input"
                          }
                          value={reviewVal}
                          onChange={(e) => {
                            setReviwVal(e.target.value);
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="w-full flex align-items-center justify-space-between my-20">
                    <p
                      className="small-text grey pointer z-3"
                      onClick={() => {
                        setToggleReviewOverlay(false);
                      }}
                    >
                      Retour
                    </p>

                    <motion.div
                      className="action-button mx-5"
                      initial={{
                        actionBtnBgColor: "#fbf008",
                        color: darkMode ? "black" : "white",
                      }}
                      animate={{
                        backgroundColor: "#fbf008",
                        color: darkMode ? "white" : "white",
                      }}
                      transition={{ duration: 0.3, ease: "easeInOut" }}
                      onClick={() => {
                        if (reviewVal !== "") {
                          setReviewClickLoading(true);
                          const reviewData = {
                            associatedProduct: selectedProduct.id,
                            createdAt: new Date().toISOString().split("T")[0],
                            createdBy: currentUser
                              ? currentUser.email
                              : "zineddinezebiri@gmail.com",
                            reviewText: reviewVal,
                            reviewerName: currentUser
                              ? currentUser.name
                              : "zineddine",
                          };

                          saveReview(reviewData)
                            .then((response) => {
                              console.log(
                                "Review saved successfully:",
                                response.key,
                              );

                              setTimeout(() => {
                                setReviewClickLoading(false);

                                setToggleReviewOverlay(false);
                                setReviwVal("");
                              }, 1000);
                            })
                            .catch((error) => {
                              console.error("Error:", error);
                            });
                        }
                      }}
                    >
                      <motion.p
                        initial={{ opacity: 0 }}
                        animate={
                          !reviewClickLoading ? { opacity: 1 } : { opacity: 0 }
                        }
                        className="btn"
                      >
                        Leave Your Comment
                      </motion.p>

                      <motion.div
                        className="btn-loader absolute flex justify-center align-items-center top0 z-1"
                        initial={{ opacity: 0 }}
                        animate={
                          reviewClickLoading ? { opacity: 1 } : { opacity: 0 }
                        }
                      >
                        <img src={whiteLoader} alt="loading" />
                      </motion.div>
                    </motion.div>
                  </div>
                </motion.div>
              </div>
            </div>
          }
        />

        <OverlayContainer
          contentHeight="90%"
          contentWidth="90%"
          className={"order-overlay"}
          darkMode={darkMode.value}
          toggleOverlay={() => setToggleProductOverlay(false)}
          stat={toggleProductOverlay}
          children={
            selectedProduct ? (
              <div>
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  className="product-page-container bold order-page"
                >
                  <img
                    alt=""
                    src={logoImg}
                    className={
                      darkMode.value
                        ? "inverted-image logo-img sportsgate-logo  mobile"
                        : "logo-img sportsgate-logo  mobile"
                    }
                  />
                  <motion.div
                    className="my- review-left "
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.8 }}
                  >
                    <p className="mobile">Commande de Produits</p>
                    <p className="small-text grey mobile">SportGates.</p>
                  </motion.div>

                  <motion.div
                    className="form-container flex-column align-items-center"
                    transition={{ delay: isInitialLoad ? 0.9 : 0 }}
                  >
                    <motion.div
                      className="mobile slider-img-container relative"
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1 }}
                      transition={{ delay: 0.8 }}
                    >
                      <AnimatePresence initial={false} mode="wait">
                        <motion.img
                          key={"images[currentImageIndex].id"}
                          src={
                            selectedVariant
                              ? selectedProduct.varients[0].imagesUrls[0]
                              : selectedProduct.imgSrc[0]
                          }
                          alt={"images[currentImageIndex].alt"}
                          className="z-2 img200"
                          initial={{ opacity: 0, scale: 0.8 }} // Initial state before animation
                          animate={{ opacity: 1, scale: 1 }} // Animate to this state
                          exit={{ opacity: 0, scale: 0.8 }} // Exit animation
                        />
                      </AnimatePresence>
                    </motion.div>

                    <Form
                      inputs={inputs}
                      actionBtnText={"Order Now"}
                      selectedNavIndex={selectedNavIndex}
                      submitHandler={handleSubmit}
                      formErrors={formErrors}
                    >
                      {/* Add your inputs here */}
                    </Form>

                   
                  </motion.div>

                  <motion.div
                    className="absolute-div"
                    initial={{ width: "45%" }}
                    animate={{ width: "35%" }}
                    transition={{ delay: 1 }}
                  >
                    <motion.img
                      src={
                        selectedVariant
                          ? selectedProduct.varients[selectedVariant - 1]
                              .imagesUrls[0]
                          : selectedProduct.imgSrc[0]
                      }
                      initial={{ right: "60%" }}
                      animate={{ right: "42%", transition: { delay: 1 } }}
                    />

                    <motion.div
                      className="rotated-back-text"
                      initial={{ left: "-30%" }}
                      animate={animations.rotatedBackText}
                      transition={{ delay: 1 }}
                    >
                      <p>MonSiteWeb.</p>
                    </motion.div>

                    <motion.div
                      className="white desc-container"
                      initial={{ left: "20%" }}
                      animate={animations.descContainer}
                      transition={{ delay: 1 }}
                    >
                      <h1 className="white z-text fit-content">
                        {selectedVariant
                          ? selectedProduct.varients[selectedVariant - 1]
                              .productName
                          : selectedProduct.name}
                      </h1>

                      <div className="flex align-items-center justify-center price my-20 black">
                        <p>
                          {selectedVariant
                            ? selectedProduct.varients[selectedVariant - 1]
                                .price
                            : selectedProduct.price}{" "}
                          <span>DA</span>
                        </p>
                      </div>
                    </motion.div>

                    <motion.div
                      className="flex align-items-center justify-center social-imgs"
                      initial={animations.socialImgsBack}
                      animate={{ bottom: "5%" }}
                      transition={{ delay: 1 }}
                    >
                      <img src={fb} className="mx-20" />
                      <img src={insta} className="mx-10" />
                      <img src={tiktok} className="mx-20" />
                    </motion.div>
                  </motion.div>
                </motion.div>

                <motion.div
                  className={
                    darkMode.value
                      ? "dark-mode top0 left0 product-overlay-loader bg-white full-width h-full flex align-items-center justify-center absolute"
                      : "top0 left0 product-overlay-loader bg-white full-width h-full flex align-items-center justify-center absolute"
                  }
                  initial={{ opacity: 1 }}
                  animate={{ opacity: 0 }}
                  transition={{ delay: 0.8 }}
                >
                  <div className="spinner"></div>
                </motion.div>
              </div>
            ) : null
          }
        ></OverlayContainer>

        <OverlayContainer
          contentHeight="85%"
          className={"cart-z"}
          contentWidth="40%"
          darkMode={darkMode.value}
          toggleOverlay={() => setToggleCartOverlay(false)}
          stat={toggleCartOverlay}
          children={
            <CartOverlayConent
              setToggleCartOverlay={setToggleCartOverlay}
              items={initialCartItems}
              setItems={setInitialCartItems}
              removeFromCart={removeFromCart}
              darkMode={darkMode.value}
              submitCartForm={() => {
                if (initialCartItems.length > 0)
                  setToggleCompleteInfosOverlay(true);
              }}
            />
          }
        />
      </motion.div>

      <div>
        <motion.div
          className="side-menu-blur mobile"
          initial={{ right: "-100%" }}
          animate={toggleFilterSideOverlay ? { right: 0 } : { right: "-110%" }}
        ></motion.div>
      </div>
      <motion.div
        className={
          darkMode.value
            ? "dark-mode side-overlay  sideMenu filter-sideMenu fixed mobile"
            : "side-overlay  sideMenu filter-sideMenu fixed mobile"
        }
        initial={{ right: "-100%" }}
        animate={toggleFilterSideOverlay ? { right: 0 } : { right: "-100%" }}
      >
        <motion.div
          className="filters-container bold absolute h-full top0 left0"
          style={darkMode.value ? { backgroundColor: "#222831" } : {}}
        >
          <p>Filter</p>
          <div className="filter-container">
            <p className="grey small-text ">Brand</p>
            <div className="filter-options">
              <SelectOption
                options={allBrands}
                onOptionSelect={setSelectedBrand}
              />
            </div>
          </div>

          {/* Category Filter */}
          <div className="filter-container">
            <p className="grey small-text my-10">Category</p>
            <div className="filter-options">
              <SelectOption
                options={[
                  "All Categories",
                  ...categoriesData.map((category) => category.categoryName),
                ]}
                onOptionSelect={setSelectedCategory}
                selectedOption={selectedCategory}
                labelBgColor={"#6363630d"}
              />
            </div>
          </div>

          {/* Subcategory Filter */}
          <div className="filter-container">
            <p className="grey small-text my-10">Sous-catégorie</p>
            <div className="filter-options">
              <SelectOption
                options={availableSubcategories.map((sub) => sub.name)}
                optionValues={availableSubcategories.map((sub) => sub.id)}
                onOptionSelect={setSelectedSubCategory}
                labelBgColor={"#6363630d"}
              />
            </div>
          </div>

          <div className="filter-container">
            <p className="grey small-text my-10">Poids</p>
            <div className="filter-options">
              <SelectOption
                options={["Tous les poids", ...allWeight]}
                optionValues={["Tous les poids", ...allWeight]}
                onOptionSelect={setSelectedWeight}
                labelBgColor={"#6363630d"}
                selectedValue={selectedWeight}
              />
            </div>
          </div>

          <div className="filter-container">
            <p className="grey small-text my-10">Tags</p>
            <div className="filter-options grid-filter-options">
              {allTags.map((tag, index) => {
                return (
                  <motion.div
                    className="filter tag"
                    initial={{ backgroundColor: "white", color: "gray" }}
                    animate={
                      selectedTags.includes(tag)
                        ? { backgroundColor: "#fbf008", color: "white" }
                        : darkMode.value
                          ? { backgroundColor: "#222831", color: "white" }
                          : { backgroundColor: "white", color: "gray" }
                    }
                    onClick={() => toggleTagSelection(tag)}
                  >
                    <p>{tag}</p>
                  </motion.div>
                );
              })}
            </div>
          </div>

          <div className="filter-container">
            <p className="grey small-text my-10">Price</p>
            <div className="filter-options">
              <input
                type="text"
                placeholder="Min Price"
                value={minPrice}
                onChange={(e) => setMinPrice(e.target.value)}
              />

              <input
                type="text"
                placeholder="Max Price"
                className="my-10"
                value={maxPrice}
                onChange={(e) => setMaxPrice(e.target.value)}
              />
            </div>
          </div>

          <div className="actions my-20 flex justify-space-between align-items-center">
            <p
              className="small-text grey my-20"
              onClick={() => setToggleFilterSideOverlay(false)}
            >
              Retour
            </p>
            <div className="my-20"></div>
          </div>
        </motion.div>
      </motion.div>

      <div>
        <motion.div
          className="side-menu-blur"
          initial={{ right: "-100%" }}
          animate={toggleSideOverlay ? { right: 0 } : { right: "-110%" }}
        ></motion.div>
      </div>
      <motion.div
        className={
          darkMode.value
            ? "dark-mode side-overlay  sideMenu fixed"
            : "side-overlay  sideMenu fixed"
        }
        initial={{ right: "-100%" }}
        animate={toggleSideOverlay ? { right: 0 } : { right: "-100%" }}
      >
        <div
          className={
            darkMode.value
              ? "dark-mode bold flex-column  overflow-auto h-full"
              : " bold flex-column  overflow-auto h-full"
          }
        >
          <div className="flex-column align-items-center justify-center w-full">
            <div className="user-circle white flex align-items-center justify-center">
              <p>{currentUser ? currentUser.name[0].toUpperCase() : ""}</p>
            </div>
            <p className="my-10">
              Salut, {currentUser ? currentUser.name : ""}.
            </p>
            <p className="small-text grey">
              {currentUser ? currentUser.email : ""}
            </p>
          </div>

          <div className="my-20">
            <div className="input-container">
              <p className="label small-text">Nom</p>
              <input
                placeholder={
                  currentUser
                    ? currentUser.displayName
                      ? currentUser.displayName
                      : currentUser.name
                    : ""
                }
              />
            </div>

            <div className="input-container">
              <p className="label small-text">Email</p>
              <input placeholder={currentUser ? currentUser.email : ""} />
            </div>

            <div className="input-container">
              <p className="label small-text">Téléphone</p>
              <input
                placeholder={
                  currentUser
                    ? currentUser.loginSrc === "email"
                      ? currentUser.dataInfos.phone
                      : currentUser.phone
                    : "Phone Number"
                }
              />
            </div>
          </div>

          <p className="small-text">Mes Commandes</p>
          <div className="my-10">
            <div className="flex fav-slider my-10 ">
              {currentUser &&
                currentUser.orders &&
                [...currentUser.orders] // clone the array to avoid mutating state
                  .sort((a, b) => new Date(b.date) - new Date(a.date)) // sort descending by date
                  .map((order) => {
                    return (
                      <div className="fav-item fit-content pointer bg-grey img100 mr-10 px-10 py-10 box-sizing border-radius-5 flex-column align-items-center justify-space-evenly">
                        <p className="smaller-text grey">{order.date}</p>
                        <p className="red">
                          {order.total}{" "}
                          <span className="smaller-text black">DA</span>
                        </p>

                        <div className="action-button bg-red">
                          <p className="btn smaller-text">See Details</p>
                        </div>
                      </div>
                    );
                  })}
            </div>
          </div>

          <div className="actions flex justify-space-between align-items-center">
            <p
              className="small-text grey my-20 pointer"
              onClick={() => setToggleSideOverlay(false)}
            >
              Back
            </p>
            <motion.div
              className="action-button mx-5"
              initial={{
                actionBtnBgColor: "#fbf008",
                color: darkMode ? "black" : "white",
              }}
              animate={{
                backgroundColor: "#fbf008",
                color: darkMode ? "white" : "white",
              }}
              transition={{ duration: 0.3, ease: "easeInOut" }}
              onClick={() => {
                setToggleSideOverlay(false);
                Swal.fire({
                  title: "Se Déconnecter",
                  html: `<p class="popup-custom-text small-text grey bold"> ${currentUser.name} , Voulez-vous vous déconnecter ?</p>`,

                  icon: "question",
                  iconColor: "#fbf008",

                  confirmButtonText: "confirmer",
                  confirmButtonColor: "#fbf008",
                  scrollbarPadding: true,

                  customClass: {
                    popup: "popup",
                    icon: "custom-icon",
                    container: "popup-container",
                    confirmButton: "confirmButton",
                    validationMessage: "validationMessage",
                    title: "popup-custom-title",
                    image: "custom-image",
                  },
                }).then((res) => {
                  if (res.isConfirmed) {
                    handleLogout();
                  }
                  //alert();
                  //logOutHandler()
                });
              }}
            >
              <p className="btn">Se Déconnecter</p>
            </motion.div>
          </div>
        </div>
      </motion.div>

      <OverlayContainer
        className={"max-z"}
        contentHeight="90%"
        contentWidth="60%"
        darkMode={darkMode.value}
        toggleOverlay={() => setToggleOverlay(false)}
        stat={toggleOverlay}
        children={
          <div className="bold login-container w-full h-full flex-column align-items-center justify-center">
            <p className="sec-text">
              Bienvenue, Une{" "}
              <span>
                autre Fois <span className="red">!</span>
              </span>
            </p>
            <p className="label">Nom d'utilisateur</p>
            <div className="input-container relative">
              <input
                placeholder="Entrez votre Nom d'utilisateur Ici"
                value={username}
                onChange={(e) => {
                  setUsername((username) => e.target.value);
                }}
              />
              <img
                src={userIcon}
                alt=""
                className="absolute right0 small-icon"
              />
            </div>
            {!showForgotPassword ? (
              <>
                <p className="label">Mot de passe</p>
                <div className="input-container relative">
                  <input
                    placeholder="Entrez votre mot de passe ici"
                    type={showPassword ? "text" : "password"}
                    value={password}
                    onChange={(e) => {
                      setPassword((password) => e.target.value);
                    }}
                  />
                  <img
                    src={PasswordIcon}
                    alt=""
                    className="absolute right0 small-icon pointer"
                    onClick={() => {
                      setShowPassword(!showPassword);
                    }}
                  />
                </div>
                <p
                  className="small-text grey my-10 pointer right-text"
                  onClick={() => setShowForgotPassword(true)}
                >
                  Mot de passe oublié ?
                </p>
              </>
            ) : (
              <>
                <p className="label">Email de récupération</p>
                <div className="input-container relative">
                  <input
                    placeholder="Entrez votre email"
                    value={resetEmail}
                    onChange={(e) => setResetEmail(e.target.value)}
                  />
                </div>
                {resetEmailSent && (
                  <p className="small-text green my-10">
                    Lien de réinitialisation envoyé ! Vérifiez votre email.
                  </p>
                )}
                <p
                  className="small-text grey my-10 pointer"
                  onClick={() => setShowForgotPassword(false)}
                >
                  Retour à la connexion
                </p>
              </>
            )}

            <div className="relative login-actions display flex justify-space-between align-items-center">
              <motion.div className="action-button  bg-red">
                <motion.p
                  className="btn"
                  initial={{ opacity: 1 }}
                  animate={!loginLoading ? { opacity: 1 } : { opacity: 0 }}
                  onClick={(e) => {
                    if (showForgotPassword) {
                      handleForgotPassword();
                    } else {
                      handleLoginClick(e);
                    }
                  }}
                >
                  {showForgotPassword ? "Envoyer le lien" : "Se Connecter"}
                </motion.p>

                <motion.div
                  className="btn-loader absolute flex justify-center align-items-center top0 z-1"
                  initial={{ opacity: 0 }}
                  animate={loginLoading ? { opacity: 1 } : { opacity: 0 }}
                >
                  <img src={whiteLoader} alt="" />
                </motion.div>
              </motion.div>

              <p
                className="small-text grey my-10 pointer"
                onClick={() => {
                  setToggleCreateAcountOverlay(true);
                }}
              >
                C'est Votre Premiere Fois Ici? Créer Votre Compte.
              </p>

              <motion.p
                className="absolute small-text grey my-10 login-err"
                initial={{ opacity: 0 }}
                animate={loginError ? { opacity: 1 } : { opacity: 0 }}
              >
                {loginError}
                {"   "}
              </motion.p>
            </div>

            <div className="half-width-hr hr my-20"></div>
            <p className="small-text my-20 flex justify-center">
              Ou, Utilisez:
            </p>

            <div className="social-container flex justify-space-evenly align-items-center">
              <div
                className="social-login-btn white "
                onClick={handleGoogleSignIn}
              >
                <img src={google} alt="" className="mx-10 small-icon" />
                <p className="btn">Google</p>
              </div>
            </div>
          </div>
        }
      />

      <OverlayContainer
        contentHeight="65%"
        contentWidth="35%"
        darkMode={darkMode.value}
        toggleOverlay={() => setToggleCompleteInfosOverlay(false)}
        stat={toggleCompleteInfosOverlay}
        children={
          <div className="bold completeForm-container w-full h-full flex-column align-items-center justify-center">
            <motion.div
              className={
                darkMode.value
                  ? "dark-mode flex-column align-items-end"
                  : "flex-column align-items-end"
              }
            >
              <p className="text">
                Vous y êtes presque, complétez vos informations.
              </p>

              {!currentUser && (
                <div className="input-container my-10">
                  <p className="label">Nom</p>
                  <input
                    placeholder="Entrez votre nom ici"
                    value={guestName}
                    onChange={(e) => setGuestName(e.target.value)}
                  />
                </div>
              )}

              <div className="input-container my-10">
                <p className="label">Téléphone</p>
                <input
                  placeholder="Entrez votre numéro de téléphone"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                />
              </div>

              <div className="input-container my-10">
                <p className="label">Wilaya</p>
                <select
                  value={wilaya}
                  onChange={(e) => setWilaya(e.target.value)}
                  className="input white wilaya-select"
                >
                  <option value="" className="black" disabled>
                    Sélectionnez votre Wilaya
                  </option>
                  {algeriaWilayas.map((wilaya, index) => (
                    <option key={index} value={wilaya} className="black">
                      {wilaya}
                    </option>
                  ))}
                </select>
              </div>

              <div className="input-container my-10">
                <p className="label">Adresse</p>
                <input
                  placeholder="Entrez votre adresse ici"
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                />
              </div>

              <div
                className="action-button bg-red my-20"
                onClick={() => completeFormHandler()}
              >
                <p className="btn">Commander maintenant</p>
              </div>
            </motion.div>
          </div>
        }
      />

      <OverlayContainer
        contentHeight="90%"
        contentWidth="35%"
        className={"signup-overlay"}
        darkMode={darkMode.value}
        toggleOverlay={() => setToggleCreateAcountOverlay(false)}
        stat={toggleCreateAcountOverlay}
        children={
          <div className="bold w-full h-full signup-overlay flex-column align-items-center justify-center relative">
            <SignUpOverlayContent
              darkMode={darkMode.value}
              showEmailVerificationOverlay={setShowEmailVerificationOverlay}
              setUsername={setUsername}
              setPassword={setPassword}
              handleLoginClick={() => handleLoginClick()}
              toggleOverlay={() => setToggleCreateAcountOverlay(false)}
            />
          </div>
        }
      />

      <OverlayContainer
        contentHeight="35%"
        contentWidth="40%"
        darkMode={darkMode.value}
        toggleOverlay={() => setShowEmailVerificationOverlay(false)}
        stat={showEmailVerificationOverlay}
        children={
          <div className="bold w-full h-full flex-column align-items-center justify-center relative">
            <p className="small-text center-text">
              Nous avons envoyé un lien de vérification à votre email, veuillez
              vérifier votre courrier et suivre les instructions.
            </p>
            <p className="small-text center-text grey my-20">
              Cette fenêtre contextuelle sera masquée une fois que vous aurez
              vérifié votre adresse email.
            </p>

            <div className="flex-column align-items-center">
              <p className="small-text center-text">
                En attente de vérification...
              </p>
              <img
                alt=""
                src={whiteLoader}
                className={
                  darkMode.value
                    ? "logo-img absolute bottom0"
                    : "inverted-image logo-img absolute bottom0"
                }
              />
            </div>
          </div>
        }
      />

      <NetTestOverlay darkMode={darkMode.value} />
      <FlashPopUp
        content={flashSaleContent}
        darkMode={darkMode.value}
        setSelectedProduct={setSelectedProduct}
        setToggleDetailOverlay={setToggleDetailOverlay}
        setReviews={setReviews}
      />
    </div>
  ) : null;
}

export default Home;
